import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { PostalballotService } from 'src/app/services/postalballot.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
declare var $: any;

@Component({
  selector: 'app-postalballot',
  templateUrl: './postalballot.component.html',
  styleUrls: ['./postalballot.component.css']
})
export class PostalballotComponent implements OnInit {

  pbForm: any;
  editPostalBallotId: any;
  editParticularData: any;
  dateofreceipt: { month: number; day: number; year: number; };
  dateofpassingresolution: { month: number; day: number; year: number; };
  addBtn: boolean;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  disabledOnClick: boolean;

  constructor(private postalballotService: PostalballotService, private activatedRoute: ActivatedRoute, private alert: AlertComponent,
    private customValidation: CustomValidation,private router: Router) { }

  ngOnInit() {
    this.pbForm = new FormGroup({
      srNoGivenByTheScrutinizer: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      nameOfShareholder: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z'.,& -]*$"), this.customValidation.noWhitespaceValidator]),
      addressOfSH: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      folioNo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$")]),
      clientIdNumberSH: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      numberOfSharesSH: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      nominalValueSH: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      detailsOfPostalBallots: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      detailPostalBallotReceived: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      differentialVotingRights: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      determinationpostalballot: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      votesInFavour: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      votesAgainst: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      invalidVotes: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      dateOfPassingResolutionPB: new FormControl('', []),
      resolutionNumber: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      resolutionName: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      nameOfScrutizer: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      addressOfScrutizer: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$")]),
      remarks: new FormControl('', []),
      dateOfReceiptpb: new FormControl('', []),
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = false;
        this.editPostalBallotId = params['particularId'];
        this.getPostalballotById(this.editPostalBallotId);
      } else {
        this.addBtn = true;
      }
    })
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['postallballotlist']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getPostalballotById(particularId) {
    this.postalballotService.updatepostalballot(particularId).subscribe(response => {
      console.log(response);
      this.editParticularData = response.data[0];
      this.pbForm.controls.srNoGivenByTheScrutinizer.setValue(this.editParticularData.srNoGivenByTheScrutinizer);
      this.pbForm.controls.nameOfShareholder.setValue(this.editParticularData.nameOfShareholder);
      this.pbForm.controls.addressOfSH.setValue(this.editParticularData.addressOfSH);
      this.pbForm.controls.folioNo.setValue(this.editParticularData.folioNo);
      this.pbForm.controls.clientIdNumberSH.setValue(this.editParticularData.clientIdNumberSH);
      this.pbForm.controls.numberOfSharesSH.setValue(this.editParticularData.numberOfSharesSH);
      this.pbForm.controls.nominalValueSH.setValue(this.editParticularData.nominalValueSH);
      this.pbForm.controls.detailsOfPostalBallots.setValue(this.editParticularData.detailsOfPostalBallots);
      this.pbForm.controls.detailPostalBallotReceived.setValue(this.editParticularData.detailPostalBallotReceived);
      this.pbForm.controls.differentialVotingRights.setValue(this.editParticularData.differentialVotingRights);
      this.pbForm.controls.votesInFavour.setValue(this.editParticularData.votesInFavour);
      this.pbForm.controls.votesAgainst.setValue(this.editParticularData.votesAgainst);
      this.pbForm.controls.invalidVotes.setValue(this.editParticularData.invalidVotes);
      this.pbForm.controls.resolutionNumber.setValue(this.editParticularData.resolutionNumber);
      this.pbForm.controls.resolutionName.setValue(this.editParticularData.resolutionName);
      this.pbForm.controls.nameOfScrutizer.setValue(this.editParticularData.nameOfScrutizer);
      this.pbForm.controls.addressOfScrutizer.setValue(this.editParticularData.addressOfScrutizer);
      this.pbForm.controls.determinationpostalballot.setValue(this.editParticularData.determinationpostalballot);
      this.pbForm.controls.remarks.setValue(this.editParticularData.remarks);

      if (this.editParticularData.dateOfPassingResolutionPB != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfPassingResolutionPB));
        this.dateofpassingresolution = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }

      if (this.editParticularData.dateOfReceiptpb != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfReceiptpb));
        this.dateofreceipt = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    }
    )
  }
  savePostalballot() {
    this.disabledOnClick = true;
    var object = {
      srNoGivenByTheScrutinizer: this.pbForm.controls.srNoGivenByTheScrutinizer.value,
      nameOfShareholder: this.pbForm.controls.nameOfShareholder.value,
      addressOfSH: this.pbForm.controls.addressOfSH.value,
      folioNo: this.pbForm.controls.folioNo.value,
      clientIdNumberSH: this.pbForm.controls.clientIdNumberSH.value,
      numberOfSharesSH: this.pbForm.controls.numberOfSharesSH.value,
      nominalValueSH: this.pbForm.controls.nominalValueSH.value,
      detailsOfPostalBallots: this.pbForm.controls.detailsOfPostalBallots.value,
      detailPostalBallotReceived: this.pbForm.controls.detailPostalBallotReceived.value,
      differentialVotingRights: this.pbForm.controls.differentialVotingRights.value,
      votesInFavour: this.pbForm.controls.votesInFavour.value,
      votesAgainst: this.pbForm.controls.votesAgainst.value,
      invalidVotes: this.pbForm.controls.invalidVotes.value,
      resolutionNumber: this.pbForm.controls.resolutionNumber.value,
      resolutionName: this.pbForm.controls.resolutionName.value,
      nameOfScrutizer: this.pbForm.controls.nameOfScrutizer.value,
      addressOfScrutizer: this.pbForm.controls.addressOfScrutizer.value,
      remarks: this.pbForm.controls.remarks.value,
      dateOfPassingResolutionPB: this.setDate(this.pbForm.controls.dateOfPassingResolutionPB.value),
      dateOfReceiptpb: this.setDate(this.pbForm.controls.dateOfReceiptpb.value),
      determinationpostalballot: this.pbForm.controls.determinationpostalballot.value
    };
    console.log("pbForm ", this.pbForm);
    console.log("object ", object);
    this.postalballotService.samplePbRecord(object).subscribe(response => {
      this.disabledOnClick = false;
      console.log('response', response);
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'postallballotlist')
      } else {
        // this.alert.error(response.message);
        if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
          this.alert.error(response.message);
        }
      }
    });
  }
  updatePostalballot(_id) {
    this.disabledOnClick = true;
    var object = {
      srNoGivenByTheScrutinizer: this.pbForm.controls.srNoGivenByTheScrutinizer.value,
      nameOfShareholder: this.pbForm.controls.nameOfShareholder.value,
      addressOfSH: this.pbForm.controls.addressOfSH.value,
      folioNo: this.pbForm.controls.folioNo.value,
      clientIdNumberSH: this.pbForm.controls.clientIdNumberSH.value,
      numberOfSharesSH: this.pbForm.controls.numberOfSharesSH.value,
      nominalValueSH: this.pbForm.controls.nominalValueSH.value,
      detailsOfPostalBallots: this.pbForm.controls.detailsOfPostalBallots.value,
      detailPostalBallotReceived: this.pbForm.controls.detailPostalBallotReceived.value,
      differentialVotingRights: this.pbForm.controls.differentialVotingRights.value,
      votesInFavour: this.pbForm.controls.votesInFavour.value,
      votesAgainst: this.pbForm.controls.votesAgainst.value,
      invalidVotes: this.pbForm.controls.invalidVotes.value,
      resolutionNumber: this.pbForm.controls.resolutionNumber.value,
      resolutionName: this.pbForm.controls.resolutionName.value,
      nameOfScrutizer: this.pbForm.controls.nameOfScrutizer.value,
      addressOfScrutizer: this.pbForm.controls.addressOfScrutizer.value,
      remarks: this.pbForm.controls.remarks.value,
      dateOfPassingResolutionPB: this.setDate(this.pbForm.controls.dateOfPassingResolutionPB.value),
      determinationpostalballot: this.pbForm.controls.determinationpostalballot.value,
      dateOfReceiptpb: this.setDate(this.pbForm.controls.dateOfReceiptpb.value),
    }
    this.postalballotService.updatePostalballot(object, this.editPostalBallotId).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'postallballotlist');
      } else {
        // this.alert.error(response.message);
        // this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');

        if(response.err_fields){
          this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
          }
          else{
            this.alert.error(response.message);
          }
      }

    })
  }

  generateOutput() {
    var object = {
      id: this.editPostalBallotId,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.postalballotService.generatePostalballotDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editPostalBallotId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editPostalBallotId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.postalballotService.downloadPostalballotFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.postalballotService.downloadPostalballotPdfFile(id, 'Single');
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }
}
